import { render, staticRenderFns } from "./SubmissionReviewItem.vue?vue&type=template&id=92cbd468&scoped=true&"
import script from "./SubmissionReviewItem.vue?vue&type=script&lang=js&"
export * from "./SubmissionReviewItem.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionReviewItem.vue?vue&type=style&index=0&id=92cbd468&scoped=true&lang=scss&"
import style1 from "./SubmissionReviewItem.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92cbd468",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VResponsive } from 'vuetify/lib/components/VResponsive';
installComponents(component, {VBtn,VCard,VCardText,VDialog,VIcon,VResponsive})
